const isEnvFlagEnabled = (value) =>
  ["true", "1", "yes", "on"].includes(String(value || "").trim().toLowerCase());

export const isMicrosoftLoginDisabled =
  isEnvFlagEnabled(process.env.REACT_APP_DISABLE_MICROSOFT_LOGIN);

export const isEntraEnabled = Boolean(
  !isMicrosoftLoginDisabled &&
    process.env.REACT_APP_AZURE_CLIENT_ID &&
    (process.env.REACT_APP_AZURE_AUTHORITY ||
      process.env.REACT_APP_AZURE_TENANT_ID)
);

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "",
    authority:
      process.env.REACT_APP_AZURE_AUTHORITY ||
      (process.env.REACT_APP_AZURE_TENANT_ID
        ? `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`
        : ""),
    redirectUri:
      process.env.REACT_APP_AZURE_REDIRECT_URI ||
      window.location.origin,
    postLogoutRedirectUri:
      process.env.REACT_APP_AZURE_REDIRECT_URI ||
      window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
  prompt: "select_account",
};
